import { withTranslation } from 'react-i18next'
import ReviewsSurveyCompetenciesSection from './ReviewsSurveyCompetenciesSection'

export default withTranslation('admin')(ReviewsSurveyCompetenciesSection)
